import type { LangCode } from "@/lib/gql/__generated__/graphql";

import { useTransitionBlock } from "@/hooks/use-transition-block";

import type { FeatureIslandHeaderLangNavigatorProps } from "@/components/features/_layouts";
import {
	FeatureIslandContainer,
	FeatureIslandHeader,
	FeatureIslandMainWithCategory,
} from "@/components/features/_layouts";

import { useInitialized } from "./model/usecase";
import { HotelPolicyI18nEditPageHeaderUpdateButton } from "./ui/components/header/update-button/update-button";
import { HotelPolicyI18nForm } from "./ui/components/question/root";
import { AccommodationHotelPolicyI18nFormModelContext } from "./ui/context";
import { hotelPolicyI18nCategoriesAndManagerStore } from "./ui/store/categories";

type Props = {
	hotelID: string;
	activeLangCode: LangCode;
	navigator: FeatureIslandHeaderLangNavigatorProps;
};

export const HotelPolicyEditI18n = ({ hotelID, activeLangCode, navigator }: Props) => {
	const init = useInitialized({ hotelID, lang: activeLangCode });
	const { categoryManagerStore } = hotelPolicyI18nCategoriesAndManagerStore;
	const { isDirty } = init.viewModel;

	useTransitionBlock(isDirty);

	return (
		<AccommodationHotelPolicyI18nFormModelContext.Provider value={{ ...init }}>
			<FeatureIslandContainer>
				<FeatureIslandHeader
					title="ホテルポリシー設定"
					activeLangCode={activeLangCode}
					navigator={navigator}
					rightChildren={<HotelPolicyI18nEditPageHeaderUpdateButton />}
				/>
				<FeatureIslandMainWithCategory categoryManagerStore={categoryManagerStore}>
					<HotelPolicyI18nForm
						hotelPolicyI18nCategoriesAndManagerStore={hotelPolicyI18nCategoriesAndManagerStore}
					/>
				</FeatureIslandMainWithCategory>
			</FeatureIslandContainer>
		</AccommodationHotelPolicyI18nFormModelContext.Provider>
	);
};
